export const NOTIFICATION = "NOTIFICATION";
export const CLEAR_NOTIFICATION = "CLEAR_NOTIFICATION";
